<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 4H1.75a.75.75 0 0 0-.75.75v13.5a.75.75 0 0 0 .75.75h13.5a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-.75-.75zm-.75 13.5h-12v-12h12v12zM19 1.75v13.5a.75.75 0 1 1-1.5 0V2.5H4.75a.75.75 0 0 1 0-1.5h13.5a.75.75 0 0 1 .75.75z"
      fill="#1A202C"
    />
  </svg>
</template>
